import { Injectable } from "@angular/core";
import { NetworkExternalConfiguration } from "src/app/ui/models/domains/pbm/network-term/network-external-configuration.model";
import { AbstractParser } from "../../parser";

@Injectable()
export class NetworkExternalConfigurationParse extends AbstractParser<NetworkExternalConfiguration> {
  parse(payload: any): NetworkExternalConfiguration {
    const networkExternalConfiguration = new NetworkExternalConfiguration();
    networkExternalConfiguration.setNetworkFiscalNumber(payload.NetworkFiscalNumber.Value);
    networkExternalConfiguration.setPricingConsultingEnable(payload.PricingConsultEnabled);
    return networkExternalConfiguration;
  }
}
